/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/* eslint-disable no-shadow */
import React from 'react';
import PropTypes from 'prop-types';
import { useFlags, NumberField } from 'sarsaparilla';
import { formatPrice } from 'ui-tree-permit/src/utils';
import { PASS_IMG_PREFIX, RESERVATIONS_ACTION_UPDATE } from '../../constants';

export default function PassTypes({
    action,
    onChangeQuantityHandler,
    passTypes,
    reservations,
}) {
    const hasPassTypes = !!passTypes.length;
    const { iaPassesGovShutdown } = useFlags();

    if (!hasPassTypes) {
        return null;
    }

    return (
        <div className="ia-pass-types">
            <table className="ia-pass-types-table">
                <thead>
                    <tr>
                        <th scope="col">Interagency Pass Options</th>
                        <th scope="col">Duration</th>
                        <th scope="col">Price</th>
                        <th scope="col">Quantity</th>
                    </tr>
                </thead>
                <tbody>
                    {passTypes.map((item) => {
                        const {
                            cost,
                            duration,
                            duration_description: durationDescription,
                            id,
                            img_url_small: imgUrlSmall,
                            name,
                        } = item;
                        const reservation = reservations.find((item) => {
                            return item?.pass_type?.id === id;
                        });
                        const value = reservation?.quantity || 0;
                        const quantityMin = action === RESERVATIONS_ACTION_UPDATE ? 1 : 0;
                        const quantityMax = 5;

                        return (
                            <tr key={`pass-type-${id}`}>
                                <td>
                                    <div className="ia-pass-type ia-pass-type-with-image">
                                        <div className="ia-pass-type-content">
                                            <div className="ia-pass-type-image-container">
                                                <img
                                                    src={`${PASS_IMG_PREFIX}${imgUrlSmall}`}
                                                    alt={name}
                                                    className="ia-pass-type-image"
                                                />
                                            </div>
                                            <div className="ia-pass-type-name">
                                                {name}
                                            </div>
                                        </div>
                                        <div className="ia-pass-type-duration">
                                            {duration}
                                        </div>
                                        <div className="ia-pass-type-duration-description">
                                            {durationDescription}
                                        </div>
                                        <div className="ia-pass-type-price">
                                            {formatPrice(cost)}
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="ia-pass-type-duration">
                                        {duration}
                                    </div>
                                    <div className="ia-pass-type-duration-description">
                                        {durationDescription}
                                    </div>
                                </td>
                                <td>
                                    <div className="ia-pass-type-price">
                                        {formatPrice(cost)}
                                    </div>
                                </td>
                                <td>
                                    <NumberField
                                        isDisabled={iaPassesGovShutdown}
                                        id={`pass-type-quantity-${id}`}
                                        units="passes"
                                        min={quantityMin}
                                        max={quantityMax}
                                        onChange={(value) => {
                                            onChangeQuantityHandler(id, value);
                                        }}
                                        value={value}
                                    />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

PassTypes.propTypes = {
    action: PropTypes.string.isRequired,
    onChangeQuantityHandler: PropTypes.func.isRequired,
    passTypes: PropTypes.array.isRequired,
    reservations: PropTypes.array.isRequired,
};
